export default {
  searchByTextPlaceholder: 'Título, autor, palabra clave...',
  topics: 'Temáticas',
  ephemeride: 'Efemérides',
  skills: 'Habilidades',
  sdg: 'ODS',
  ageRange: 'Rango etario',
  subjects: 'Áreas cruzadas',
  clear: 'Limpiar',
  popularContent: 'Contenido destacado',
  popularAuthors: 'Autores populares',
  noResult: 'No se encontraron resultados'
}

export const en = {
  searchByTextPlaceholder: 'Title, author, keyword...',
  topics: 'Topics',
  ephemeride: 'Events and celebrations',
  skills: 'Skills',
  sdg: 'SDG',
  ageRange: 'Age',
  subjects: 'Curriculum areas',
  clear: 'Clear',
  popularContent: 'Featured content',
  popularAuthors: 'Popular authors',
  noResult: 'No results found'
}

export const ca = {
  searchByTextPlaceholder: 'Títol, autor, paraula clau...',
  topics: 'Temàtiques',
  ephemeride: 'Efemèrides',
  skills: 'Habilitats',
  sdg: 'ODS',
  ageRange: 'Edat',
  subjects: 'Àrees creuades',
  clear: 'Netejar',
  popularContent: 'Contingut destacat',
  popularAuthors: 'Autors populars',
  noResult: 'Sense resultats'
}
